<template>
  <preview-pane :loaded="loaded"
    :title="machineData && machineData.DisplayName ? machineData.DisplayName : 'Preview machine'">

    <template v-slot:header v-if="showToolbar">
      <v-toolbar dense flat class="minitoolbar">
        <!--
        <QButtonGroup v-model="JobPreviewPaneMode"
                      :list="[
                        { text:'minimal', value:'minimal' }, 
                        { text:'text', value: 'text' }
                      ]"
                      :noempty="true"
                      :edit="true"
                      :color="'primary'">
        </QButtonGroup>
        -->

        <v-spacer />

        <v-btn color="tertiary" dark small @click="changeModelTrigger++">
          {{ $t('servicesystem.common_objects.machine.change_model') }}
        </v-btn>
        <v-btn color="secondary" small class="mx-3" @click="changeOwnerTrigger++">
          {{ $t('servicesystem.common_objects.machine.change_owner') }}
        </v-btn>

        <v-btn color="primary" small :to="{ name: 'ViewMachine', params: { machineId: id } }">
          <v-icon class="mr-2" size="15" v-text="'open_in_full'" />
          {{ $t('servicesystem.common_objects.commonterms.open') }}
        </v-btn>

        <ActionMenu :actionList="actionlist" :parentcontext="thiscontext" class="ml-3">
        </ActionMenu>
      </v-toolbar>
    </template>

    <template v-slot:panels>
      <template v-if="!customerId">
        <section-header :title="$t('servicesystem.common_objects.customer.customer')" :notoppad="true">
        </section-header>
        <template v-if="customerData">
          <CustomerDetailsPreview :CustomerData="customerData" :loading="customerLoading" class="mt-3">
          </CustomerDetailsPreview>

          <CustomerAddressPreview :CustomerAddress="customerData.DefaultDeliveryAddress" :loading="customerLoading">
          </CustomerAddressPreview>

          <CustomerContactPreview :CustomerContact="customerData.DefaultCustomerPerson" :loading="customerLoading">
          </CustomerContactPreview>
        </template>
        <section-header :title="$t('servicesystem.common_objects.machine.machine')"></section-header>
      </template>

      <v-card class="rounded-0" style="width: 100%;">
        <MachineListItem :machine="machineData" disabled class="ml-n5" :showServiceAgreement="false">
        </MachineListItem>
      </v-card>

      <expanding-object :model="MDmodel" :object="machineData" :loading="machineLoading" class="mt-0">
        <template v-slot:additional-content>
          <MachineContractHoverCard v-if="ContractsLicence" :id="machineData ? machineData.Id : null" />
        </template>
      </expanding-object>

      <slotted-expancion-panel :title="$t('servicesystem.common_objects.machine.preventative_maintenance')"
        :icon="'mdi-spray-bottle'" :disabled="false">
        <template v-slot:content>
          <switch-li :label="$t('servicesystem.common_objects.machine.service_agreement')"
            :value="machineData && machineData.ServiceAgreement ? machineData.ServiceAgreement : false">
          </switch-li>
          <FieldPrinter v-if="AddedFields" :sourceObject="machineData" :fieldList="AddedFields['MachineDetails']"
            :groupRestriction="'PreventativeMaintenance'">
          </FieldPrinter>
        </template>
      </slotted-expancion-panel>
      <!-- TODO: add relevant sneak peak -->

      <!--
      <slotted-expancion-panel
        :title="$t('servicesystem.common_objects.machine.service_level_measurement')"
        :icon="'mdi-cash-multiple'"
        :disabled="true"
      >
        <template v-slot:content>
          <v-list dense class="py-0 pl-3">
            <v-list-item>{{$t('servicesystem.common_objects.machine.cost')}}</v-list-item>
            <v-list-item>{{$t('servicesystem.common_objects.machine.parts')}}</v-list-item>
            <v-list-item>{{$t('servicesystem.common_objects.machine.work_and_diving')}}</v-list-item>
            <v-list-item>{{$t('servicesystem.common_objects.machine.total')}}</v-list-item>
            <v-list-item>{{$t('servicesystem.common_objects.machine.difference_from_yealy')}}</v-list-item>
          </v-list>
        </template>
      </slotted-expancion-panel>
      -->
      <!-- TODO: add relevant sneak peak -->
      <!--
      <expanding-list :list="documentData"
                      :title="$t('servicesystem.common_objects.machine.machine_documents')"
                      :icon="'mdi-file-multiple'"
                      :listitem="{ key: 'Id', textkey: 'Name' }"
                      :loading="documentLoading">
      </expanding-list>
      -->
      <slotted-expancion-panel :title="$t('servicesystem.common_objects.machine.machine_counters')"
        :icon="'mdi-counter'" :disabled="false">
        <template v-slot:content>
          <MachineCountersCardContent :machineId="id">
          </MachineCountersCardContent>
        </template>
      </slotted-expancion-panel>

      <section-header :title="$t('servicesystem.common_objects.job.jobs')">
        <template v-slot:button>
          <v-btn :to="{
            name: 'NewJobOverview',
            params: { filter: 'my' },
            query: { customerId: customerId ? customerId : (customerData ? customerData.Id : undefined), machineId: machineData.Id }
          }" color="quaternary" class="white--text" small>{{ $t('servicesystem.common_objects.commonterms.new')
            }}</v-btn>
        </template>
      </section-header>

      <UpcomingJobs :id="machineData ? machineData.Id : null" :machine="true" />

      <ActiveJobs :id="machineData ? machineData.Id : null" :machine="true" />

      <ClosedJobs :id="machineData ? machineData.Id : null" :machine="true" />

      <ChangeMachineOwnerDialog :externaltrigger="changeOwnerTrigger" :machineId="machineData.Id"
        :currentCustomerId="(customerId ? customerId : (customerData ? customerData.Id : undefined))">
      </ChangeMachineOwnerDialog>
      <ChangeModelInfoDialog :externaltrigger="changeModelTrigger" :machine="machineData"
        @Update="val => setMachine(val)">
      </ChangeModelInfoDialog>
      <MachineQrDialog :key="id" :machineId="id" :trigger="qrTrigger">
      </MachineQrDialog>
    </template>
  </preview-pane>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ExpandingObject from "@/components/ExpancionPanels/Generic/ExpandingObject.vue";
import SectionHeader from "@/components/ExpancionPanels/Parts/SectionHeader.vue";
import SwitchLi from "@/components/Inputs/SwitchListItem.vue";
import MachineListItem from "@/components/ListItems/MachineListItem.vue";
import ActiveJobs from "@/components/Preview/ActiveJobsPreview.vue";
import ClosedJobs from "@/components/Preview/ClosedJobsPreview.vue";
import CustomerAddressPreview from "@/components/Preview/Customer/CustomerAddressPreview.vue";
import CustomerContactPreview from "@/components/Preview/Customer/CustomerContactPreview.vue";
import CustomerDetailsPreview from "@/components/Preview/Customer/CustomerDetailsPreview.vue";
import UpcomingJobs from "@/components/Preview/UpcomingJobsPreview.vue";
import MachineContractHoverCard from "@/views/job/newjob/cards/machines/MachineContractHoverCard.vue";
import MachineCountersCardContent from "@/views/job/newjob/cards/machines/MachineCountersCardContent.vue";
import PreviewPane from "@/views/layouts/PreviewPane.vue";
import SlottedExpancionPanel from "@/views/layouts/SlottedExpancionPanel.vue";

import CustomerEditModel from "@/helpers/Models/Customer-Edit-Model";
import MachineDetailsEditModel from "@/helpers/Models/Machine-Details-Edit-Model";

import FieldPrinter from "@/components/SingleUse/FieldPrinter.vue";

import ChangeMachineOwnerDialog from "@/components/Dialogs/ChangeMachineOwnerDialog.vue";
import ChangeModelInfoDialog from "@/components/Dialogs/ChangeModelInfoDialog.vue";
import MachineQrDialog from "@/components/SingleUse/MachineQrDialog.vue";

import ActionMenu from "@/components/Buttons/ActionMenu.vue";

export default {
  name: "PreviewMachine",
  props: ["id", "customerId", "showToolbar",],
  components: {
    PreviewPane,
    SectionHeader,
    SlottedExpancionPanel,
    ExpandingObject,
    SwitchLi,
    FieldPrinter,
    MachineContractHoverCard,
    UpcomingJobs,
    ActiveJobs,
    ClosedJobs,
    CustomerDetailsPreview,
    CustomerAddressPreview,
    CustomerContactPreview,
    MachineListItem,
    ChangeMachineOwnerDialog,
    ChangeModelInfoDialog,
    MachineQrDialog,
    ActionMenu,
    MachineCountersCardContent,
  },
  mixins: [clientAPI],

  data() {
    return {
      MDmodel: MachineDetailsEditModel,
      Cmodel: CustomerEditModel,

      machineData: { Id: this.id },
      customerData: null,
      documentData: null,
      counterData: null,
      historyData: null,

      customerLoading: false,
      machineLoading: false,
      documentLoading: false,
      countersLoading: false,

      changeOwnerTrigger: 1,
      changeModelTrigger: 1,
      qrTrigger: 1,

      thiscontext: this,
    };
  },

  mounted() {
    this.getMachine();
  },

  methods: {
    setMachine(data) {
      this.machineData = data;
      this.$emit("Update", data);
    },

    getMachine() {
      this.machineLoading = true;
      this.getMachineById(this.id)
        .then((response) => {
          this.machineData = response;
          //console.log("machine", response);
          this.getCustomer();
          //this.getDocuments();
          this.getCounters();
        })
        .catch((e) => {
          console.error(e);
          this.machineData = false;
        })
        .finally(() => (this.machineLoading = false));
    },

    getCustomer() {
      this.customerLoading = true;
      this.getCustomerById(this.machineData.CustomerId)
        .then((response) => {
          this.customerData = response;
        })
        .catch((/*exception*/) => {
          this.customerData = false;
        })
        .finally(() => (this.customerLoading = false));
    },

    getDocuments() {
      this.documentLoading = true;
      this.getMachineDocuments(this.machineData.Id)
        .then((response) => {
          this.documentData = response;
        })
        .catch((/*exception*/) => {
          this.documentData = false;
        })
        .finally(() => (this.documentLoading = false));
    },

    getCounters() {
      this.countersLoading = true;
      this.getCountersByMachineId(this.machineData.Id)
        .then((response) => {
          this.counterData = response;
        })
        .catch((/*exception*/) => {
          this.counterData = false;
        })
        .finally(() => (this.countersLoading = false));
    },

    groupBy(array, key) {
      const output = {};
      array.forEach((item) => {
        if (!output[item[key]]) {
          output[item[key]] = {
            Id: item.CounterId,
            Name: item.Counter.Name,
            Global: item.Counter.Global,
            IsActive: item.Counter.IsActive,
            Value: item.Value,
            History: [],
          };
        }
        output[item[key]].History.push(item);
      });

      return output;
    },

    openInNewTab() {
      let newPageRoute = this.$router.resolve({ name: 'ViewMachine', params: { machineId: this.id } });
      window.open(newPageRoute.href, "_blank");
    },
    openQrDialog() {
      this.qrTrigger++;
    },
  },

  computed: {
    publicModeEnabled() {
      return this.$store.state.GlobalSettings.Features.PublicPortalEnabled;
    },

    loaded() {
      var result = !this.machineLoading && !this.customerLoading && !this.documentLoading && !this.countersLoading;
      return result;
    },

    machineCounters() {
      if (this.machineData && this.machineData.MachineCounters) {
        return Object.values(this.groupBy(this.machineData.MachineCounters, "CounterId"));
      } else {
        return [];
      }
    },

    actionlist() {
      var list = [
        {
          title: this.$t("servicesystem.common_objects.document.open_in_new_tab"),
          icon: "mdi-open-in-new",
          iconsize: 16,
          hovercolor: "primary",
          method: "openInNewTab",
        },
      ];
      if (this.publicModeEnabled && this.machineData && this.machineData.Qrcode) { //&& this.customerData && this.customerData.AllowPublicView
        var qritem = {
          title: 'Show public QR',
          icon: "mdi-qrcode",
          iconsize: 18,
          hovercolor: "tertiary",
          method: "openQrDialog",
        };
        list.push(qritem);
      }
      return list;
    },
  },

  watch: {
    id: function () {
      this.getMachine();
    },
    "$route.query.timestamp"() {
      this.getMachine();
    },
  },
};
</script>

<style>
.listheader {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: rgba(249, 249, 249, 0.713) !important;
}
</style>